import { ComparisonEntry, ComparisonSide } from '../types'
import { BRANDS } from './brands'
import { MOLECULES } from './molecules'
import { approvedContent, unreviewed } from './shared'

/** The nine canonical comparisons with approved Part B source copy. */
export const COMPARISON_SLUGS = [
  'mounjaro-ou-wegovy',
  'mounjaro-ou-ozempic',
  'mounjaro-ou-ozivy',
  'wegovy-ou-ozempic',
  'wegovy-ou-poviztra',
  'wegovy-ou-ozivy',
  'semavy-ou-ozempic',
  'ozivy-ou-ozempic',
  'semaglutida-ou-tirzepatida'
] as const

/** Reserved for future public 301s; today used only inside the preview namespace. */
export const COMPARISON_REDIRECTS: Readonly<Record<string, string>> = {
  '/poviztra-ou-wegovy': '/wegovy-ou-poviztra',
  '/ozivy-ou-wegovy': '/wegovy-ou-ozivy'
}

const resolveSide = (slug: string): ComparisonSide & { name: string } => {
  const brand = BRANDS.find((entry) => entry.slug === slug)
  if (brand) return { kind: 'brand', slug, name: brand.name }
  const molecule = MOLECULES.find((entry) => entry.slug === slug)
  if (molecule) return { kind: 'molecule', slug, name: molecule.name }
  throw new Error(`medleveSeo: comparison side "${slug}" is not a registered brand or molecule`)
}

/** Builds a comparison entry from an `a-ou-b` slug. Both sides must already exist in the registries. */
export const buildComparison = (slug: string): ComparisonEntry => {
  const [leftSlug, rightSlug, ...rest] = slug.split('-ou-')
  if (!leftSlug || !rightSlug || rest.length) throw new Error(`medleveSeo: invalid comparison slug "${slug}"`)
  const left = resolveSide(leftSlug)
  const right = resolveSide(rightSlug)

  return {
    kind: 'comparison',
    slug,
    path: `/${slug}`,
    name: `${left.name} ou ${right.name}`,
    left: { kind: left.kind, slug: left.slug },
    right: { kind: right.kind, slug: right.slug },
    published: false,
    requiresReview: true,
    review: unreviewed()
  }
}

/** REQUIRES MEDICAL REVIEW — comparison rows are intentionally empty. */
export const COMPARISONS: ComparisonEntry[] = COMPARISON_SLUGS.map(buildComparison).map(approvedContent)
